import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Modulos from "..";
import { useUserInfor } from "../../../Context/User";
import { IOrgModulo } from "../../../Interfaces/Organizacao/Organizacao";

interface IModulo {
    ID_MODULO: number;
    DS_MODULO: string;
    ID_VINCULO?: number;
    vinculado?: boolean;
}
interface IVinculadorDeModulosProps<T> {
    id: number;

    listarVinculados: (id: number) => Promise<Array<T>>;
    vincular: (id: number, idModulo: number) => Promise<void>;
    desvincular: (idVinculador: number) => Promise<void>;
    find: (row: T, idModulo: number) => boolean;
    filter?: (moduloOrg: IOrgModulo) => boolean;
    getIdVinculador: (row: T | undefined) => number | undefined;

    onModulosLoad?: (modulos: Array<T>) => void;
}
interface IModuloVincularProps
    extends Pick<
        IVinculadorDeModulosProps<never>,
        "vincular" | "desvincular" | "id"
    > {
    modulo: IModulo;
    updateModulos: () => void;
}

export default function VinculadorDeModulos<T>(
    props: IVinculadorDeModulosProps<T>
) {
    const [lstModulos, setLstModulos] = useState([] as Array<IModulo>);
    const [lstModulosLoad, setLstModulosLoad] = useState<Array<T>>([]);

    const orgModulos = useUserInfor().OrgInfor.MODULOS;

    const { find, filter, listarVinculados, getIdVinculador, onModulosLoad } =
        props;

    const updateModulos = useCallback(() => {
        listarVinculados(props.id).then(setLstModulosLoad);
    }, [props.id, listarVinculados]);

    useEffect(() => {
        updateModulos();
    }, [updateModulos]);

    useEffect(() => {
        const modulos = filter ? orgModulos?.filter(filter) : orgModulos;
        setLstModulos(
            modulos?.map((orgModulo) => {
                const moduloVinculado = lstModulosLoad.find((m) =>
                    find(m, orgModulo.ID_MODULO)
                );
                const vinculado = moduloVinculado !== undefined;
                return {
                    ID_MODULO: orgModulo.ID_MODULO,
                    DS_MODULO: orgModulo.DS_MODULO,
                    ID_VINCULO: getIdVinculador(moduloVinculado),
                    vinculado,
                };
            }) || []
        );

        if (onModulosLoad) onModulosLoad(lstModulosLoad);
    }, [
        lstModulosLoad,
        onModulosLoad,
        find,
        filter,
        getIdVinculador,
        orgModulos,
    ]);

    return (
        <div className="modulos d-flex flex-wrap">
            {lstModulos.map((modulo) => {
                return (
                    <ModuloVincular
                        {...props}
                        key={modulo.ID_MODULO}
                        modulo={modulo}
                        updateModulos={updateModulos}
                    />
                );
            })}
        </div>
    );
}

function ModuloVincular(props: IModuloVincularProps) {
    const { modulo, updateModulos, desvincular, vincular, id } = props;
    const [loading, setLoading] = useState(false);
    return (
        <OverlayTrigger
            key={modulo.ID_MODULO}
            overlay={(props) => (
                <Tooltip id={`${modulo.ID_MODULO}-tooltip`} {...props}>
                    {modulo.DS_MODULO}
                </Tooltip>
            )}
        >
            <div
                onClick={() => {
                    if (!loading) {
                        setLoading(true);
                        if (modulo.vinculado && modulo.ID_VINCULO) {
                            desvincular(modulo.ID_VINCULO)
                                .then((res) => {
                                    updateModulos();
                                })
                                .finally(() => setLoading(false));
                        } else {
                            vincular(id, modulo.ID_MODULO)
                                .then(() => {
                                    updateModulos();
                                })
                                .finally(() => setLoading(false));
                        }
                    }
                }}
            >
                {Modulos(
                    modulo.ID_MODULO,
                    modulo.DS_MODULO,
                    `modulo ${modulo.vinculado ? "active" : "disabled"}`
                )}
            </div>
        </OverlayTrigger>
    );
}
